module.exports = __webpack_public_path__ + "static/celine-cc3fc33bb362b57b78e1205a055a9323.png";